import React from "react";
import { FaTruck, FaGlobe, FaArrowsAltH, FaDollarSign, FaPercent, FaThumbsUp } from "react-icons/fa";
import testimon from "../../assets/rightbeanie.png";
import testimonial from "../../assets/Banner Beanies.png";
import testimonia from "../../assets/bannermake.png";




const features = [
  {
    id: 1,
    icon: <FaTruck className="text-2xl text-white" />,
    title: "5 Day Production, Low Minimums",
    desc: "Our Fast option produces patches in five days — available for select patch types, including options with low minimums starting at just 10 patches.",
  },
  {
    id: 2,
    icon: <FaGlobe className="text-2xl text-white" />,
    title: "High Quality Materials",
    desc: "Our patches feature premium threads and durable fabrics for sharp, vibrant designs that endure daily wear and washing.",
  },
  {
    id: 3,
    icon: <FaArrowsAltH className="text-2xl text-white" />,
    title: "Versatile Attachment Options",
    desc: "We offer various backing options, including heat press, iron-on, peel-and-stick, and Velcro, to suit your application needs.",
  },
  {
    id: 4,
    icon: <FaDollarSign className="text-2xl text-white" />,
    title: "No Setup or Art Fees",
    desc: "To keep our embroidered patches and other patch types affordable, there are no set up or art fees.",
  },
  {
    id: 5,
    icon: <FaPercent className="text-2xl text-white" />,
    title: "Bulk Order Discounts",
    desc: "Save up to 74% on bulk orders — the more you buy, the more you save!",
  },
  {
    id: 6,
    icon: <FaThumbsUp className="text-2xl text-white" />,
    title: "Satisfaction Guarantee",
    desc: "Report production errors within 45 days for a replacement or refund. No returns needed before approval.",
  },
];

const WhyBuySection = () => {
  return (
    <section className="w-full py-0 px-6 max-w-7xl mx-auto">

      <div className="bg-gray-50 py-10 px-4">
  <div className="max-w-6xl mx-auto space-y-10">

    {/* SECTION 1 */}
    <div className="py-10 px-4 bg-gradient-to-b from-gray-50 to-white">
      <img
  src={testimonial}
  alt="Beanies"
  className="w-full h-auto rounded-xl shadow-md object-cover"
/>
  
</div>


{/*New Section 2 of humanized content */}





    {/* SECTION 2 */}
    <div className="py-0 px-4 bg-gradient-to-b from-gray-50 to-white">
  <div className="py-10 px-4 bg-gray-50">
  <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">

    {/* LEFT CONTENT */}
    <div>
      
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
        Why Choose High-Quality Blank Beanies?
      </h2>

      <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6">
        Consistency matters. High-quality blanks ensure better results, durability, and a professional finish.
      </p>

      <div className="grid sm:grid-cols-2 gap-4">
        {[
          "Lightweight & comfortable",
          "Durable shape retention",
          "Embroidery & print ready",
          "Consistent sizing",
          "Reliable supply"
        ].map((item, i) => (

          <div
            key={i}
            className="bg-white px-4 py-3 rounded-md border border-gray-100 text-gray-700 text-sm shadow-sm hover:shadow-md transition"
          >
            {item}
          </div>

        ))}
      </div>
    </div>

    {/* RIGHT IMAGE */}
    <div className="w-full">
      <img
      src={testimon}
      alt="Beanies"
      className="w-full h-auto rounded-xl shadow-md object-cover"
      />
    </div>

  </div>
</div>
</div>

{/*New Section of humanized content */}

<div className="relative overflow-hidden rounded-[28px] bg-[#f5f6f5] py-14 md:py-20 md:rounded-[40px]">
  {/* Soft theme background */}
  <div className="absolute inset-0 pointer-events-none">
    <div className="absolute -top-28 -right-28 h-72 w-72 rounded-full bg-[#1e242a]/5 blur-3xl"></div>
    <div className="absolute -bottom-32 -left-32 h-80 w-80 rounded-full bg-[#37404a]/10 blur-3xl"></div>
  </div>

  <div className="relative z-10 container mx-auto px-4 sm:px-6 md:px-10">
    <div className="max-w-5xl">
     

      <h2 className="mt-5 mb-8 whitespace-normal text-2xl font-extrabold leading-tight tracking-tight text-[#1e242a] sm:text-3xl md:mb-12 md:text-4xl lg:whitespace-nowrap lg:text-5xl">
  Order blank beanies with Flexibility and Control
</h2>

      <div className="mb-10 max-w-5xl">
        <p className="mb-4 text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          You're either a business owner, reseller, or a designer and you need something that will scale to your requirements.
        </p>

        <p className="mb-4 text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          That's why many customers prefer to order blank beanies in bulk or wholesale formats.
        </p>

        <p className="text-base font-bold leading-relaxed text-[#1e242a] md:text-lg">
          Available options include:
        </p>
      </div>
    </div>

    <div className="mb-10 grid grid-cols-1 gap-5 sm:grid-cols-2 md:gap-7 lg:grid-cols-4">
      <div className="h-full rounded-2xl border border-[#1e242a]/10 bg-white p-6 shadow-[0_18px_35px_rgba(30,36,42,0.10)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_rgba(30,36,42,0.16)] md:p-8">
        <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-[#e5e8e6] text-2xl font-bold text-[#1e242a]">
          ○
        </div>
        <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          plain beanies in bulk for large-scale requirements
        </p>
      </div>

      <div className="h-full rounded-2xl border border-[#1e242a]/10 bg-white p-6 shadow-[0_18px_35px_rgba(30,36,42,0.10)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_rgba(30,36,42,0.16)] md:p-8">
        <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-[#e5e8e6] text-2xl font-bold text-[#1e242a]">
          ○
        </div>
        <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          blank beanies wholesale/bulk pricing for cost efficiency
        </p>
      </div>

      <div className="h-full rounded-2xl border border-[#1e242a]/10 bg-white p-6 shadow-[0_18px_35px_rgba(30,36,42,0.10)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_rgba(30,36,42,0.16)] md:p-8">
        <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-[#e5e8e6] text-2xl font-bold text-[#1e242a]">
          ○
        </div>
        <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          plain beanie hats wholesale for retail or branding use
        </p>
      </div>

      <div className="h-full rounded-2xl border border-[#1e242a]/10 bg-white p-6 shadow-[0_18px_35px_rgba(30,36,42,0.10)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_rgba(30,36,42,0.16)] md:p-8">
        <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-[#e5e8e6] text-2xl font-bold text-[#1e242a]">
          ○
        </div>
        <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          Reliable access to blank beanies wholesale/Bulk with consistent quality
        </p>
      </div>
    </div>

    <div className="max-w-5xl rounded-2xl border border-[#1e242a]/10 bg-white p-6 shadow-sm md:p-8">
      <p className="mb-4 text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
        If you've been searching for blank beanies near me, ordering online gives you broader access without location limits. It is easy and reliable to source products in the USA.
      </p>

      <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
        designed to be customized and branded.
      </p>
    </div>
  </div>
</div>




    {/* SECTION 3 */}
   <div className="py-14 px-4 bg-gray-50">
    
  <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">

    {/* LEFT */}
    <div className="space-y-5">
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
        Reliable Supply Across the USA
      </h2>

      <p className="text-gray-600 text-sm leading-relaxed">
        We ensure smooth operations with consistent inventory, fast processing,
        and reliable fulfillment — so your business never slows down.
      </p>

      <ul className="space-y-2">
        {[
          "Trusted supply chain",
          "Fast order handling",
          "Scalable for bulk needs"
        ].map((item, i) => (
          <li key={i} className="flex items-center gap-2 text-gray-700 text-sm">
            <span className="w-2 h-2 bg-[#407d69] rounded-full"></span>
            {item}
          </li>
        ))}
      </ul>
    </div>

    {/* RIGHT */}
    <div className="grid grid-cols-2 gap-4">
      {[
        "Fast inventory access",
        "Consistent availability",
        "Competitive bulk pricing",
        "Smooth ordering process"
      ].map((item, i) => (
        <div
          key={i}
          className="bg-white p-5 rounded-lg border border-gray-100 text-center shadow-sm hover:shadow-md transition"
        >
          <p className="text-gray-700 text-sm font-medium">
            {item}
          </p>
        </div>
      
      ))}
    </div>







  </div>
</div>

{/*New Section of humanized content */}
<div className="bg-[#f5f6f5] py-12 sm:py-14 md:py-16 lg:py-20">
  <div className="container mx-auto px-4 sm:px-6 md:px-10">
    <div className="relative overflow-hidden rounded-3xl bg-[#1e242a] px-5 py-8 sm:px-7 sm:py-10 md:rounded-[40px] md:px-10 md:py-12 lg:px-14 lg:py-14">
      
      {/* Decorative Shapes */}
      <div className="pointer-events-none absolute -right-12 -top-12 h-32 w-32 rounded-full bg-white/10 blur-2xl sm:h-40 sm:w-40 md:h-52 md:w-52"></div>
      <div className="pointer-events-none absolute -left-14 -bottom-14 h-36 w-36 rounded-full bg-[#e5e8e6]/10 blur-2xl sm:h-44 sm:w-44 md:h-56 md:w-56"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-[#1e242a] via-[#37404a] to-[#5f6870] opacity-95"></div>

      <div className="relative z-10 grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-10 xl:gap-14">
        
        {/* Content */}
        <div className="text-center lg:col-span-7 lg:text-left">
          <span className="mb-5 inline-flex items-center justify-center rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#e5e8e6] shadow-sm backdrop-blur-sm sm:text-sm">
            Ready to Order
          </span>

          <h2 className="mx-auto max-w-3xl text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-3xl md:text-4xl lg:mx-0 lg:text-5xl">
            Start Your Order for wholesale/bulk blank beanies Today
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/85 sm:text-base md:text-lg lg:mx-0">
            You can make a big impact on the final product or brand presentation by selecting the correct beanies to upgrade your supply, should you be willing to do that.
          </p>
        </div>

        {/* Feature Box */}
        <div className="w-full lg:col-span-5">
          <div className="rounded-2xl border border-white/10 bg-white p-4 shadow-2xl sm:p-5 md:rounded-[28px] md:p-6 lg:p-7">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-1">
              <div className="rounded-xl bg-[#e5e8e6] px-4 py-3 text-sm font-semibold text-[#1e242a] sm:px-5 sm:py-4 sm:text-base">
                Premium materials
              </div>

              <div className="rounded-xl bg-[#e5e8e6] px-4 py-3 text-sm font-semibold text-[#1e242a] sm:px-5 sm:py-4 sm:text-base">
                Flexible order quantities
              </div>

              <div className="rounded-xl bg-[#e5e8e6] px-4 py-3 text-sm font-semibold text-[#1e242a] sm:px-5 sm:py-4 sm:text-base">
                Custom-ready surfaces
              </div>

              <div className="rounded-xl bg-[#e5e8e6] px-4 py-3 text-sm font-semibold text-[#1e242a] sm:px-5 sm:py-4 sm:text-base">
                In bulk and wholesale.
              </div>
            </div>

            <div className="mt-5 rounded-2xl bg-[#1e242a] p-5 text-center sm:p-6 lg:text-left">
              <h3 className="text-lg font-extrabold leading-tight text-white sm:text-xl md:text-2xl">
                Order Blank Beanies Now
              </h3>

              <p className="mt-3 text-sm leading-relaxed text-white/85 sm:text-base">
                Get reliable blank beanies wholesale options designed to support your business and creative needs.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>





    {/* SECTION 4 */}
<div className="py-16 px-4">
  <img
  src={testimonia}
  alt="Beanies"
  className="w-full h-auto rounded-xl shadow-md object-cover"
/>
  <div className="max-w-5xl mx-auto">

    
    

   

  </div>
</div>

    {/* CTA */}
<div className="relative overflow-hidden rounded-2xl bg-[#1e242a] p-8 shadow-[0_18px_45px_rgba(30,36,42,0.22)] md:p-10">
  {/* Theme Gradient Overlay */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#1e242a] via-[#37404a] to-[#5f6870]"></div>

  {/* Decorative Blur Circles */}
  <div className="pointer-events-none absolute -top-10 -right-10 h-40 w-40 rounded-full bg-white/10 blur-2xl"></div>
  <div className="pointer-events-none absolute -bottom-12 -left-12 h-44 w-44 rounded-full bg-[#e5e8e6]/10 blur-2xl"></div>

  <div className="relative z-10 flex flex-col items-center justify-between gap-8 md:flex-row">
    {/* LEFT CONTENT */}
    <div className="max-w-md text-center md:text-left">
      <h2 className="mb-3 text-2xl font-extrabold leading-snug tracking-tight text-white md:text-3xl">
        Start Your Order Today
      </h2>

      <p className="text-sm leading-relaxed text-white/85 md:text-base">
        Premium quality beanies ready for customization. Built for comfort, durability, and style.
      </p>
    </div>

    {/* FEATURES */}
    <div className="flex flex-wrap justify-center gap-3 md:justify-end">
      {["Premium Materials", "Flexible Quantities", "Bulk Options"].map((item, i) => (
        <span
          key={i}
          className="rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm font-semibold text-[#e5e8e6] backdrop-blur-md transition-colors duration-300 hover:bg-white/15"
        >
          {item}
        </span>
      ))}
    </div>
  </div>
</div>

  </div>
</div>

{/*New Section 3 of humanized content */}

<div className="bg-[#f5f6f5] py-14 md:py-20">
  <div className="container mx-auto px-4 sm:px-6 md:px-10">
    <div className="grid grid-cols-1 items-stretch gap-8 lg:grid-cols-2 lg:gap-12">
      
      {/* Left Content */}
      <div className="relative overflow-hidden rounded-[28px] bg-[#1e242a] p-6 sm:p-8 md:rounded-[40px] md:p-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1e242a] via-[#37404a] to-[#5f6870]"></div>
        <div className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full bg-white/10 blur-3xl"></div>
        <div className="pointer-events-none absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-[#e5e8e6]/10 blur-3xl"></div>

        <div className="relative z-10 flex h-full flex-col justify-center">
          <h2 className="mb-6 text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-3xl md:text-4xl">
            Our blank sublimation beanies are designed with customization in mind.
          </h2>

          <p className="text-sm leading-relaxed text-white/85 sm:text-base md:text-lg">
            They offer a smooth and even surface that is compatible with:
          </p>

          <ul className="mt-6 space-y-4">
            <li className="flex items-center gap-4 text-sm leading-relaxed text-white/90 sm:text-base md:text-lg">
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#e5e8e6] text-[#1e242a] shadow-sm">
                ✓
              </span>
              <span>Embroidery</span>
            </li>

            <li className="flex items-center gap-4 text-sm leading-relaxed text-white/90 sm:text-base md:text-lg">
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#e5e8e6] text-[#1e242a] shadow-sm">
                ✓
              </span>
              <span>Heat transfer designs</span>
            </li>

            <li className="flex items-center gap-4 text-sm leading-relaxed text-white/90 sm:text-base md:text-lg">
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#e5e8e6] text-[#1e242a] shadow-sm">
                ✓
              </span>
              <span>Patches</span>
            </li>

            <li className="flex items-center gap-4 text-sm leading-relaxed text-white/90 sm:text-base md:text-lg">
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#e5e8e6] text-[#1e242a] shadow-sm">
                ✓
              </span>
              <span>Printing and sublimation</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Right Content */}
      <div className="rounded-[28px] border border-[#1e242a]/10 bg-white p-6 shadow-[0_18px_35px_rgba(30,36,42,0.10)] sm:p-8 md:rounded-[40px] md:p-10">
        <p className="mb-6 text-xl font-extrabold leading-tight tracking-tight text-[#1e242a] sm:text-2xl md:text-3xl">
          This makes them ideal for:
        </p>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="rounded-2xl border border-[#1e242a]/10 bg-[#e5e8e6] p-5 text-sm font-semibold leading-relaxed text-[#1e242a] sm:text-base md:text-lg">
            Clothing brands
          </div>

          <div className="rounded-2xl border border-[#1e242a]/10 bg-[#e5e8e6] p-5 text-sm font-semibold leading-relaxed text-[#1e242a] sm:text-base md:text-lg">
            Promotional merchandise
          </div>

          <div className="rounded-2xl border border-[#1e242a]/10 bg-[#e5e8e6] p-5 text-sm font-semibold leading-relaxed text-[#1e242a] sm:text-base md:text-lg">
            Sports teams
          </div>

          <div className="rounded-2xl border border-[#1e242a]/10 bg-[#e5e8e6] p-5 text-sm font-semibold leading-relaxed text-[#1e242a] sm:text-base md:text-lg">
            Retail collections
          </div>
        </div>

        <p className="mt-8 text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          Also, in contrast to conventional alternatives, these beanies do not lose their shape when tailored, so they can be used over the long term.
        </p>
      </div>
    </div>
  </div>
</div>





     
     {/*New Section of humanized content */}

<div className="bg-[#f5f6f5] py-14 md:py-20">
  <div className="container mx-auto px-4 sm:px-6 md:px-10">
    <div className="relative overflow-hidden rounded-[28px] bg-[#1e242a] p-6 sm:p-8 md:rounded-[42px] md:p-12">
      {/* Theme Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1e242a] via-[#37404a] to-[#5f6870]"></div>
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-28 -left-28 h-80 w-80 rounded-full bg-[#e5e8e6]/10 blur-3xl"></div>

      <div className="relative z-10 grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12">
        {/* Left Heading Area */}
        <div className="lg:col-span-5">
         

          <h2 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl md:text-5xl">
            Why Choose High Quality Blank Beanies?
          </h2>

          <p className="mt-6 text-sm leading-relaxed text-white/85 sm:text-base md:text-lg">
            Not all suppliers offer the same level of consistency when it comes to best beanie blanks.
          </p>

          <p className="mt-4 text-sm leading-relaxed text-white/85 sm:text-base md:text-lg">
            Here's what you should expect from high quality blank beanies:
          </p>
        </div>

        {/* Right Feature Cards */}
        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="rounded-2xl border border-white/10 bg-white p-5 shadow-sm">
              <div className="flex items-start gap-4">
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-[#e5e8e6] font-bold text-[#1e242a]">
                  01
                </span>
                <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base">
                  Lightweight, plush materials that are comfortable to wear on a head.
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white p-5 shadow-sm">
              <div className="flex items-start gap-4">
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-[#e5e8e6] font-bold text-[#1e242a]">
                  02
                </span>
                <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base">
                  Good stitching and becomes shapeless.
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white p-5 shadow-sm">
              <div className="flex items-start gap-4">
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-[#e5e8e6] font-bold text-[#1e242a]">
                  03
                </span>
                <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base">
                  Embroidery and sublimation compatibility with materials.
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white p-5 shadow-sm">
              <div className="flex items-start gap-4">
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-[#e5e8e6] font-bold text-[#1e242a]">
                  04
                </span>
                <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base">
                  Consistent sizing of orders in bulk.
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white p-5 shadow-sm sm:col-span-2">
              <div className="flex items-start gap-4">
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-[#e5e8e6] font-bold text-[#1e242a]">
                  05
                </span>
                <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base">
                  Repeat purchase inventory position.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Note */}
      <div className="relative z-10 mt-8 rounded-2xl border border-white/10 bg-white/95 p-5 shadow-sm md:mt-10 md:p-6">
        <p className="mb-4 text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          You also get options that support Wholesale beanies made in usa no minimum, giving flexibility for both small and large buyers.
        </p>

        <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          For businesses, this means you can confidently choose blank beanies no minimum wholesale without being locked into large upfront commitments.
        </p>
      </div>
    </div>
  </div>
</div>

{/*New Section of humanized content  */}

<div className="bg-[#f5f6f5] py-14 md:py-20">
  <div className="container mx-auto px-4 sm:px-6 md:px-10">
    <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12">
      
      {/* Left Cards */}
      <div className="order-2 lg:order-1 lg:col-span-6">
        <div className="rounded-[28px] border border-[#1e242a]/10 bg-white p-5 shadow-[0_18px_35px_rgba(30,36,42,0.10)] sm:p-6 md:rounded-[40px] md:p-8">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="rounded-2xl border border-[#1e242a]/10 bg-[#f5f6f5] p-5 shadow-sm">
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl border border-[#1e242a]/10 bg-[#1e242a] text-sm font-bold text-white">
                  01
                </span>
                <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base">
                  Faster access to inventory
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-[#1e242a]/10 bg-[#f5f6f5] p-5 shadow-sm">
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl border border-[#1e242a]/10 bg-[#1e242a] text-sm font-bold text-white">
                  02
                </span>
                <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base">
                  Regular supply of products.
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-[#1e242a]/10 bg-[#f5f6f5] p-5 shadow-sm">
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl border border-[#1e242a]/10 bg-[#1e242a] text-sm font-bold text-white">
                  03
                </span>
                <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base">
                  Attractive prices in order sizes.
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-[#1e242a]/10 bg-[#f5f6f5] p-5 shadow-sm">
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl border border-[#1e242a]/10 bg-[#1e242a] text-sm font-bold text-white">
                  04
                </span>
                <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base">
                  Smooth ordering experience
                </p>
              </div>
            </div>
          </div>

          <div className="mt-5 rounded-2xl border border-[#1e242a]/10 bg-[#e5e8e6] p-5">
            <p className="text-sm leading-relaxed text-[#1e242a] sm:text-base md:text-lg">
              Whether you need a small batch or blank beanies wholesale/bulk, the process is designed to be simple and efficient.
            </p>
          </div>
        </div>
      </div>

      {/* Right Content */}
      <div className="order-1 lg:order-2 lg:col-span-6">
        <span className="inline-flex rounded-full border border-[#1e242a]/10 bg-white px-5 py-2 text-xs font-bold uppercase tracking-[0.2em] text-[#37404a] shadow-sm">
          USA Supply
        </span>

        <h2 className="mb-6 mt-5 text-3xl font-extrabold leading-tight tracking-tight text-[#1e242a] sm:text-4xl md:text-5xl">
          A Reliable Source for Blank Beanies in the USA
        </h2>

        <p className="mb-5 text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
          Instead of repeatedly searching for blank beanies near me, you can access a centralized solution that serves customers across the United States.
        </p>

        <p className="text-base font-bold leading-relaxed text-[#1e242a] md:text-lg">
          This approach offers:
        </p>
      </div>

    </div>
  </div>
</div>




    </section>
  );
};

export default WhyBuySection;
